<script>
  import { flip } from "svelte/animate";
  import { dndzone } from "svelte-dnd-action";
  import { getHeaders } from "../headers.svelte";

  export let items, listingId;
  const flipDurationMs = 300;

  function handleDndConsider(e) {
    items = e.detail.items;
  }

  async function deleteMedia(listingMediaId) {
    if (!window.confirm("Êtes vous certain(e) de vouloir supprimer cette image")) {
      return;
    }

    const res = await fetch(
      `/listings/${listingId}/listing_medias/${listingMediaId}`,
      {
        headers: getHeaders(),
        method: 'DELETE',
      }
    );

    if (res.ok) {
      items = items.filter((item) => {
        return item.id != listingMediaId
      })
    }
  }

  async function handleDndFinalize(e) {
    items = e.detail.items;

    let itemsForPost = items.map((item, idx) => {
      return {id: item.id, position: idx}
    })

    const res = await fetch(
      `/listings/${listingId}/reorder_medias`,
      {
        headers: getHeaders(),
        method: 'POST',
        body: JSON.stringify({listing_medias: itemsForPost})
      }
    );

    if (res.ok) {

    } else {
      throw new Error();
    }

  }
</script>

<section class="my-6 grid grid-cols-2 md:grid-cols-3 gap-4"
  use:dndzone="{{items, flipDurationMs, dropTargetStyle: ''}}"
  on:consider="{handleDndConsider}"
  on:finalize="{handleDndFinalize}">
  {#each items as item(item.id)}
  <div class="rounded-[8px] first:border-[3px] border-secondary" animate:flip="{{duration: flipDurationMs}}">
    <div class="relative">
      <img src="{item.url}" alt="{item.id}" class="rounded-[4px] object-fit w-full">
      <div class="cursor-pointer absolute flex items-center justify-center w-6 h-6 rounded-full gap-x-[2px] bg-gray-100/80 top-2 right-2" on:click={() => deleteMedia(item.id)}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="trash"
          class="w-3 h-3 text-gray-700 fill-current"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512">
            <path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z">
          </path>
        </svg>

      </div>
    </div>
  </div>
  {/each}
</section>
